import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// ── UI Store — sidebar, layout, loading ───────────────────────────────────────

interface UIState {
  /** Dark mode toggle (persisted across sessions) */
  darkMode: boolean
  /** Global page-level loading overlay */
  pageLoading: boolean

  // Actions
  toggleDarkMode: () => void
  setPageLoading: (loading: boolean) => void
}

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      darkMode: false,
      pageLoading: false,

      toggleDarkMode: () => set((s) => ({ darkMode: !s.darkMode })),
      setPageLoading: (loading) => set({ pageLoading: loading }),
    }),
    {
      name: 'mc-erp-ui',
      // Persist dark mode — not loading flags
      partialize: (state) => ({
        darkMode: state.darkMode,
      }),
    },
  ),
)
